//Main states: 'hovering new', creating: new, unsaved, saved not derived, saved derived, loaded derived, loaded not derived

var _ = require('underscore'),
    Raphael = require('raphael'),

    /* (note: both extend from shape */
    ShapeDialogView = require('../shapeWithDialog'),
    GraphicShapeView = require('../graphic/graphic'),

    SignatureUIModel = require('./signatureUIModel'),
    SignatureBottomTextView = require('./bottomText/bottomText'),
    SignatureDialog = require('./dialog/dialog'),
    SignatureDialogBtn = require('../selectSet/btn/signatureDialogBtn'),
    SaveSigBtn = require('../selectSet/btn/saveSignature'),
    SignatureEl = require('./createSignatureEl');


require('extendRaphael');


var instanceVars = {
    os: null, // orig scale for bottom text scaling - when create new if toggled after scale change; ( put on uiModel ? )
    signatureModel: null, // new one for each, otherwise used on alternatives!!
    bottomText: null // the 'bottom text view', which may or may not exist; if it does, will also need to be on the shape model; note: presence indicates action
};

// make this a separate module if extend more ... ok for now b/c only init overwritten

var DialogGraphicShape = GraphicShapeView.extend(
    ShapeDialogView.prototype
);


module.exports = DialogGraphicShape.extend({
    initialize: function(options) {

        _.extend(this, instanceVars, _.pick(options, 'signatureModel'), {
            os: options.scale,
            signatureModel: new SignatureUIModel()
        });

        ShapeDialogView.prototype.initialize.call(this, _.extend(options, {
            dialogConstructor: SignatureDialog,
            dialogOptions: {
                signatureModel: this.signatureModel
            },
            dialogBtnConstructor: SignatureDialogBtn
        }));

        this.bindEntityEvents(this.signatureModel,  this.signatureUISubs);

    },

    shapeSubs: _.extend( {}, DialogGraphicShape.prototype.shapeSubs, {
        'shape.move shape.resizeRect shape.onAfterBaseScale':   'onAfterBaseShapeScale',     //repo children is really the secondary scale intended for the children
        'shape.resizeEnd shape.moveEnd':                        'moveOrResizeEnd'
    }),

    signatureUISubs: {
        'change:activeFont':                'fontChangeCB',
        'change:showBottomText':            'toggleBottomText'
    },

    makeExpandedVisibleIndicator: DialogGraphicShape.prototype._createGlow,

    moveOrResizeEnd: function() {
        this.trigger('signature.moveOrResizeEnd'); /* pass down to children */
    },
    fontChangeCB: function () {

        /* get b/f remove */
        var elBox = Raphael.pathBBox( this.el.attr('path') );
        var currentColor = this.el.attr('fill');

        this.el.remove();

        // Note: this is off elbox x, y though below should resolve
        this.el = SignatureEl(
            this.paper,
            elBox.x,
            elBox.y, // must adjust for this -- baseline is 'middle' -- (unless use borderView, see below)
            this.pgNoteModel.get('creationUserDesc'),
            this.signatureModel.get('activeFont'),
            currentColor
        );

        this.el.fitAndPositionPathToMatchAnother( this.borderView.el ); /* use the border view; otherwise need to adjust the calc'd box's y position */

        // Update original el
        this.shapeUI.set('raphaelEl', this.el);
        this.setElement(this.el);

        this._enableMove();

    },
    /* note, this is now assuming on create (only newly created... */
    toggleBottomText: function(m, show) {

        if (show) {

            this.bottomText = new SignatureBottomTextView( _.extend( _.clone(this.options), {
                parent: this
            })).render();

            // if not a shape but its path needs to be passed like one
            // alternative to save on model? (unnecessary dupe ref?)
            // stored b/c not access to view when re-rendering
            this.shapeModel['bottomText'] = this.bottomText;

        } else {
            this.bottomText.destroy();
            delete this.shapeModel.bottomText;
        }

    },

    /**
     * If for more shapes have a child that needs to change color, trigger from the base shape
     * take the fill applied for the above shape as it's 'derived'
     * Note: Graphic has different implementation than DialogGraphicShape
     * ( if more shapes extend, dialog graphic shape should point to that version )
     */
    noteConsultGroupChange: function() {

        GraphicShapeView.prototype.noteConsultGroupChange.apply(this, arguments);
        this.trigger('signature.noteConsultGroupChange', this.el.attr('fill') );

    },

    onAfterButtonSetCreation: function(isSelected) {
        ShapeDialogView.prototype.onAfterButtonSetCreation.apply(this, arguments);
        isSelected && this.btnSet.addBtn('save', SaveSigBtn, 1);
    },
    onAfterBaseShapeScale: function( signatureBBox, scale, lastScale ) {

        // reposition the bottom text
        this.trigger.call(this, 'signature.repositionBottomText', signatureBBox );

        /**
         * If expanded, scale the glow.
         * Note: this will include the bottom text because when saved, it's read as one element.
         * The signature can only be expanded when saved.
         */
        this.resetGlow();

    },
    onBeforeDestroy: function () {

        this.bottomText && this.bottomText.destroy();

        DialogGraphicShape.prototype.onBeforeDestroy.apply(this, arguments);
        GraphicShapeView.prototype.onBeforeDestroy.apply(this, arguments);

        this.unbindEntityEvents(this.signatureModel,  this.signatureUISubs);
        this.signatureModel.destroy();

        //TODO: events not cleaned ...
        this.stopListening();
        this.off();

    }

});





/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/signature/signature.js
 ** module id = 211
 ** module chunks = 0
 **/